<div class="modal-overlay" *ngIf="isVisible">
  <div class="modal-content" #modalContent>
    <div class="modal-header">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-lg flex items-center justify-center" [ngClass]="getIconClass()">
          <span class="material-symbols-outlined text-lg">{{ config.icon || 'warning' }}</span>
        </div>
        <h2 class="text-lg font-semibold text-gray-900">{{ config.title }}</h2>
      </div>
      <button class="modal-close-btn" (click)="onClose()" type="button" [disabled]="config.isLoading">
        <span class="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
    
    <div class="modal-body">
      <div class="text-gray-700" [innerHTML]="config.message"></div>
      <div *ngIf="config.warningMessage" class="bg-red-50 border border-red-200 rounded-lg p-4 mt-4">
        <div class="flex items-start gap-3">
          <span class="material-symbols-outlined text-red-600 text-lg flex-shrink-0 mt-0.5">info</span>
          <div class="text-sm text-red-800" [innerHTML]="config.warningMessage"></div>
        </div>
      </div>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="modal-btn-secondary" (click)="onCancel()" [disabled]="config.isLoading">
        <span class="material-symbols-outlined text-base">close</span>
        <span>{{ config.cancelText || 'Annuler' }}</span>
      </button>
      <button type="button" [ngClass]="config.confirmButtonClass || 'modal-btn-primary'" (click)="onConfirm()" [disabled]="config.disabled || config.isLoading">
        <span *ngIf="!config.isLoading" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">{{ config.confirmButtonClass?.includes('delete') ? 'delete' : 'check' }}</span>
          <span>{{ config.confirmText || 'Confirmer' }}</span>
        </span>
        <span *ngIf="config.isLoading" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>En cours...</span>
        </span>
      </button>
    </div>
  </div>
</div>
